import React from 'react';
import PropType from 'prop-types';

const ProgressBar = props => (
  props.children ?
    <div>
      <div className="dtp-progress-bar" />
      <span>{props.children}</span>
    </div>
    :
    <div>
      <div className="dtp-progress-bar" />
    </div>
);

ProgressBar.propTypes = {
  children: PropType.element,
};

ProgressBar.defaultProps = {
  children: null,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/ProgressBar.jsx